/* Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import * as storageUtils from '@/utils/storageUtils';
import InfoComponent from '@/components/infoComponent/InfoComponent';
import { useTranslations } from '@/hooks/useTranslations';
import { FlexBox, IllustratedMessage } from '@ui5/webcomponents-react';
import { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

const TooManyRequests = () => {
    const { t } = useTranslations();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!storageUtils.getItem('user')) {
            navigate('/login');
        }
    }, [navigate]);

    const isFromError = location.state && location.state.fromError === true;
    if (!isFromError) {
        return <Navigate to="/" replace />;
    }

    return (
        <FlexBox data-testid="429_error_FlexBox" justifyContent="Center" alignItems="Center" style={{ height: '100vh' }}>
            <IllustratedMessage
                data-testid="429_error_IllustratedMessage"
                name="ReloadScreen"
                titleText={t('TOO_MANY_REQUESTS_TITLE')}
                subtitleText={t('TOO_MANY_REQUESTS_DESCRIPTION')}
            >
                <InfoComponent />
            </IllustratedMessage>
        </FlexBox>
    );
};

export default TooManyRequests;
